module.exports = __webpack_public_path__ + "img/9.cd489dc9.jpg";